import { IRoblexEnviroment } from '../interfaces/roblex-enviroment.interface';

export const RoblexEnviromentProd: IRoblexEnviroment = {
    identitiesUrl: 'https://identities.roblex.pe',
    operationsUrl: 'https://operations.roblex.pe',
    promotionsUrl: 'https://promotions.roblex.pe',
    verificationsUrl: 'https://verifications.roblex.pe',
    searchPromotionUrl: 'https://roblex.pe/#/promociones',
    notificationUrl: 'https://alerts.pe/#/promociones',
    reviewsUrl: 'https://reviews.roblex.pe',
};
